import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUnlink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { onMounted, ref, watch } from "vue";
import localize from "@/utils/localization";
import ClickToEdit from "@/components/Collections/common/ClickToEdit.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PairedElementView',
    props: {
        pair: null,
        unlinkFn: null
    },
    emits: ["onPairRename"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faUnlink);
        const name = ref("");
        watch(() => props.pair, () => {
            name.value = props.pair.name;
        });
        watch(name, () => {
            emit("onPairRename", name.value);
        });
        onMounted(() => {
            name.value = props.pair.name;
        });
        return { __sfc: true, props, emit, name, faUnlink, FontAwesomeIcon, localize, ClickToEdit };
    }
});
